import { OnInit, Input, Output, Component, EventEmitter } from '@angular/core';
import { LoaderService } from '../../../infrastructure/services/loader.service';

@Component({
  selector: 'sx-text-area',
  templateUrl: './textArea.component.html',
  styleUrls: ['./formWidgets.css'],
})
export class TextAreaComponent implements OnInit {
  // Texto inicial
  @Input() texto: string;
  @Input() deshabilitado: string;

  // Evento cuando el usuario acepta el cambio del texto
  @Output() textoCambiado: EventEmitter<string> = new EventEmitter();

  textoLocal: string;
  editando = false;
  error: string = null;

  ngOnInit() {
    this.textoLocal = this.texto;
  }

  confirmarEdicion() {
    if (!this.validarDescripcionExt(this.texto)) {
      return;
    }

    this.textoCambiado.emit(this.texto);
    this.editando = false;
    this.error = null;
  }

  initEdition(){
    this.editando = true;
    this.textoLocal = this.texto;
  }

  deshacerEdicion() {
    this.texto = this.textoLocal
    this.editando = false;
    this.error = null;
  }

  // TODO: Implementar un servicio de validaciones
  // que haga este trabajo
  private validarDescripcionExt(valor: string, error?: string) {
    if (valor && valor.length > 255) {
      this.error = 'Debe tener como máximo 255 caracteres.';
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/textArea.component.ts